import { render, staticRenderFns } from "./configEditor.vue?vue&type=template&id=4af1269c&scoped=true"
import script from "./configEditor.vue?vue&type=script&lang=js"
export * from "./configEditor.vue?vue&type=script&lang=js"
import style0 from "./configEditor.vue?vue&type=style&index=0&id=4af1269c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1269c",
  null
  
)

export default component.exports